import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d79bcee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products-panel" }
const _hoisted_2 = { class: "order-product__base-row" }
const _hoisted_3 = { class: "order-product__image-cover product-image-cover" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "order-product__info product-info" }
const _hoisted_6 = { class: "product-info__base-row" }
const _hoisted_7 = { class: "product-info__name" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "product-info__description" }
const _hoisted_10 = {
  key: 1,
  class: "product-info__dash"
}
const _hoisted_11 = { class: "product-info__properties-list" }
const _hoisted_12 = { class: "product-property" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product-property__option" }, " Количество ", -1))
const _hoisted_14 = { class: "product-property__value" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "order-product__actions-row product-actions product-actions--mobile" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "order-product__price product-price" }
const _hoisted_20 = { class: "product-price__per-unit" }
const _hoisted_21 = { class: "rouble-symbol rouble-symbol--small-indent" }
const _hoisted_22 = {
  key: 1,
  class: "product-old-price__per-unit rouble-symbol rouble-symbol--small-indent"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1))
const _hoisted_24 = {
  key: 2,
  class: "product-price__discount-percent"
}
const _hoisted_25 = { class: "product-price__total-price" }
const _hoisted_26 = {
  key: 0,
  class: "product-price__per-unit-with-quantity rouble-symbol rouble-symbol--small-indent price-item"
}
const _hoisted_27 = { class: "rouble-symbol price-item" }
const _hoisted_28 = {
  key: 1,
  class: "product-price__old-total-price rouble-symbol price-item"
}
const _hoisted_29 = {
  key: 0,
  class: "order-product__cooking-time-warning order-product__cooking-time-warning--mobile"
}
const _hoisted_30 = { class: "order-product__actions-row product-actions product-actions--desktop" }
const _hoisted_31 = { class: "order-product__cooking-time-warning" }
const _hoisted_32 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FinalPricePanel = _resolveComponent("FinalPricePanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItems, (orderItem) => {
      return (_openBlock(), _createElementBlock("div", {
        key: orderItem.id,
        class: "order-product"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("img", {
              src: orderItem?.product?.image,
              alt: orderItem.name
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(orderItem?.name) + " ", 1),
                (!_ctx.isSingleOptionItem(orderItem))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(orderItem.productOption.title) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (orderItem.productOption.weight)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(orderItem.productOption.weight) + " г ", 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (orderItem.productOption.title && orderItem.productOption.description)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " - "))
                  : _createCommentVNode("", true),
                (orderItem?.productOption?.description)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.replacedHtmlTags(orderItem.productOption.description)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: _normalizeClass([
                    'product-property__control',
                    'product-property__control--decrement',
                    {
                      'product-property__control--disabled':
                        orderItem.quantity <= 1 || false,
                    },
                  ]),
                    type: "button",
                    onClick: ($event: any) => (_ctx.$emit('decreaseItemQuantity', orderItem.id))
                  }, null, 10, _hoisted_15),
                  _createTextVNode(" " + _toDisplayString(orderItem.quantity) + " ", 1),
                  _createElementVNode("button", {
                    class: _normalizeClass([
                    'product-property__control',
                    'product-property__control--increment',
                    {
                      'product-property__control--disabled': false,
                    },
                  ]),
                    type: "button",
                    onClick: ($event: any) => (_ctx.$emit('increaseItemQuantity', orderItem.id))
                  }, null, 8, _hoisted_16)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "product-actions__remove",
                type: "button",
                onClick: ($event: any) => (_ctx.$emit('deleteItem', orderItem.id))
              }, " Удалить ", 8, _hoisted_18)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$filters.formattedNumber(orderItem.price)), 1),
              (orderItem.productOption.hasStopPrice)
                ? (_openBlock(), _createBlock(_component_FinalPricePanel, {
                    key: 0,
                    "with-panel-title": true,
                    class: "final-price"
                  }))
                : _createCommentVNode("", true),
              (orderItem.priceWithoutDiscount !== orderItem.price)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$filters.formattedNumber(orderItem.priceWithoutDiscount)), 1))
                : _createCommentVNode("", true),
              _hoisted_23,
              (orderItem.discountPercent)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(orderItem.discountPercent), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              (orderItem.quantity > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(orderItem.quantity) + " x " + _toDisplayString(_ctx.$filters.formattedNumber(orderItem.price)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$filters.formattedNumber(orderItem.totalPrice)), 1),
              (orderItem.totalPrice !== orderItem.totalPriceWithoutDiscount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$filters.formattedNumber(orderItem.totalPriceWithoutDiscount)), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (orderItem.productOption.cookingTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Этот товар замедляет получение, доступен " + _toDisplayString(_ctx.orderStore.getCookingDateString(orderItem.productOption.cookingTime)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            (orderItem.productOption.cookingTime)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Этот товар замедляет получение, доступен " + _toDisplayString(_ctx.orderStore.getCookingDateString(orderItem.productOption.cookingTime)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "product-actions__remove",
            type: "button",
            onClick: ($event: any) => (_ctx.$emit('deleteItem', orderItem.id))
          }, " Удалить ", 8, _hoisted_32)
        ])
      ]))
    }), 128))
  ]))
}